import React from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import WidgetCard from './WidgetCard'

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
`

const Tile = styled.button`
  appearance: none;
  border: 1px solid
    ${(p) =>
      p.$logged ? p.theme?.color?.accent || '#6B9080' : p.theme?.color?.border || '#E6E0D6'};
  background: ${(p) =>
    p.$logged ? p.theme?.color?.accentSoft || '#E1ECE7' : p.theme?.color?.bgRaised || '#fff'};
  border-radius: 14px;
  padding: 14px 16px;
  text-align: left;
  cursor: pointer;
  font-family: inherit;
  &:hover { border-color: ${(p) => p.theme?.color?.primary || '#1F3A5F'}; }
`

const Label = styled.div`
  font-weight: 600;
  color: ${(p) => p.theme?.color?.ink || '#1F2937'};
  margin-bottom: 4px;
`

const State = styled.div`
  font-size: 13px;
  color: ${(p) => p.theme?.color?.inkMuted || '#6B7280'};
`

const keyForMetric = (m) =>
  m === 'BP' ? 'vital_bp' : m === 'WEIGHT' ? 'vital_weight' : m === 'SLEEP_HOURS' ? 'vital_sleep' : null

export default function VitalsToLogCard({ data, onLog }) {
  const navigate = useNavigate()
  if (!data || data.length === 0) return null

  return (
    <WidgetCard title="Vitals to log">
      <Grid>
        {data.map((v) => {
          const key = keyForMetric(v.metric)
          return (
            <Tile
              key={v.metric}
              $logged={v.loggedToday}
              onClick={() => {
                if (v.loggedToday) {
                  navigate('/patient-home/care/vitals')
                  return
                }
                if (key && onLog) onLog(key)
              }}
            >
              <Label>{v.label}</Label>
              <State>{v.loggedToday ? 'Logged' : 'Tap to log'}</State>
            </Tile>
          )
        })}
      </Grid>
    </WidgetCard>
  )
}
